import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=061bd420&"
import script from "./ErrorLogs.vue?vue&type=script&lang=js&"
export * from "./ErrorLogs.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061bd420')) {
      api.createRecord('061bd420', component.options)
    } else {
      api.reload('061bd420', component.options)
    }
    module.hot.accept("./ErrorLogs.vue?vue&type=template&id=061bd420&", function () {
      api.rerender('061bd420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/developerTools/ErrorLogs.vue"
export default component.exports